import fetchClient from '../components/common/FetchClient';

const requestPriceCalcType = 'REQUEST_PRICING_CALCULATOR';
const receivePriceCalcType = 'RECEIVE_PRICING_CALCULATOR';
const initialState = { customer: '', productId: '', unitOfMeasure: '', product: '', isLoading: false, showDetails: false };

export const actionCreators = {
    queryPriceCalc: queryData => async (dispatch, getState) => {
        var customer = queryData['customer'];
        var addressId = queryData['addressId'];
        var productId = queryData['productId'];
        var unitOfMeasure = queryData['unitOfMeasure'];

        var newPrice = 0.0;
        if (queryData['newPrice']) {
            newPrice = queryData['newPrice'];
        }
        var updatePrice = false;
        if (queryData['updatePrice']) {
            updatePrice = queryData['updatePrice'];
        }

        dispatch({ type: requestPriceCalcType, productId, unitOfMeasure, customer, addressId });

        const url = `/api/PricingCalculator/GetCustomerItemData`;
        await fetchClient(url, {
            params: {
                azureToken: '',
                customer: customer,
                addressId: addressId,
                productId: productId,
                unitOfMeasure: unitOfMeasure,
                updatePrice: updatePrice,
                newPrice: newPrice
            }
        })
        .then(function (resp) {
            console.log(resp);
            if (resp) {
                var product = resp.data;
                
                dispatch({ type: receivePriceCalcType, product, productId, unitOfMeasure, customer, addressId });
            }
        });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestPriceCalcType) {
        return {
            ...state,
            productId: action.productId,
            unitOfMeasure: action.unitOfMeasure,
            customer: action.customer,
            addressId: action.addressId,
            isLoading: true
        };
    }

    if (action.type === receivePriceCalcType) {
        return {
            ...state,
            product: action.product.Product,
            test: action.product,
            productId: action.productId,
            unitOfMeasure: action.unitOfMeasure,
            customer: action.customer,
            addressId: action.addressId,
            isLoading: false
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/PricingCalculator.js